// Chakra imports
import {
  Box,
  Flex,
  Icon,
  Text,
  Image,
  Link,
  List,
  ListItem,
  useColorModeValue,
} from "@chakra-ui/react";
import PropTypes from "prop-types";

import logo from "assets/img/logo/full-logo.png";

// Custom components
import { NavLink } from "react-router-dom";
// Assets
import { FaChevronLeft } from "react-icons/fa";

function AuthIllustration(props: {
  children: JSX.Element | string;
  illustrationBackground: string;
}) {
  const { children, illustrationBackground } = props;
  let linkColor = useColorModeValue({ base: "gray.400", lg: "white" }, "white");
  // Chakra color mode
  return (
    <Flex position="relative" h="max-content">
      <Flex
        h={{
          sm: "initial",
          md: "unset",
          lg: "100vh",
          xl: "97vh",
        }}
        w="100%"
        maxW={{ md: "66%", lg: "1313px" }}
        mx="auto"
        pt={{ sm: "50px", md: "0px" }}
        px={{ lg: "30px", xl: "0px" }}
        ps={{ xl: "70px" }}
        justifyContent="start"
        direction="column"
      >
        <NavLink
          to="/admin"
          style={() => ({
            width: "fit-content",
            marginTop: "40px",
            display: "none",
          })}
        >
          <Flex
            align="center"
            ps={{ base: "25px", lg: "0px" }}
            pt={{ lg: "0px", xl: "0px" }}
            w="fit-content"
          >
            <Icon
              as={FaChevronLeft}
              me="12px"
              h="13px"
              w="8px"
              color="secondaryGray.600"
            />
            <Text ms="0px" fontSize="sm" color="secondaryGray.600">
              Volver al inicio
            </Text>
          </Flex>
        </NavLink>
        {children}
        <Box
          display={{ base: "none", md: "block" }}
          h="100%"
          minH="100vh"
          w={{ lg: "50vw", "2xl": "44vw" }}
          position="absolute"
          right="0px"
        >
          <Flex
            bg={`url(${illustrationBackground})`}
            w="100%"
            h="100%"
            bgSize="cover"
            bgPosition="50%"
            position="absolute"
            borderBottomLeftRadius={{ lg: "120px", xl: "200px" }}
            direction="column"
          >
            <Image
              src={logo}
              alignSelf="center"
              ml="30px"
              filter="brightness(0) invert(1);"
              mt="25vh"
            />
            <List
              display="flex"
              justifyContent="space-between"
              w="45%"
              alignSelf="center"
              mt={{base: '20vh', '2xl': '26vh'}}
              ml="30px"
            >
              <ListItem>
                <Link
                  fontWeight="500"
                  color={linkColor}
                  href="https://wa.me/584123450002"
				  target="_blank"
                >
                  Parawita
                </Link>
              </ListItem>
              <ListItem>
                <Link
                  fontWeight="500"
                  color={linkColor}
                  href="http://intranet.grupoparawa.com"
				  target="_blank"
                >
                  Intranet
                </Link>
              </ListItem>
              <ListItem>
                <Link
                  fontWeight="500"
                  color={linkColor}
                  href="https://handshake.grupoparawa.com/"
				  target="_blank"
                >
                  Handshake
                </Link>
              </ListItem>
            </List>
          </Flex>
        </Box>
        {/*<Footer />*/}
      </Flex>
      {/*<FixedPlugin />*/}
    </Flex>
  );
}
// PROPS

AuthIllustration.propTypes = {
  illustrationBackground: PropTypes.string,
  image: PropTypes.any,
};

export default AuthIllustration;
